import React from 'react';
import { AlertHighIcon, AlertLowIcon, AlertMediumIcon, BodyText, Heading2, Modal, AllDone } from '@kallidus/common';
import { node, oneOf, string } from 'prop-types';
import SuccessIcon from '@kallidus/common/lib/esm/components/Alert/SuccessIcon';
import './InformationalModalBase.less';

const INFORMATIONAL_ICONS = {
  success: SuccessIcon, // has viewbox, 24
  info: AlertLowIcon, // no viewbox, 24
  advisory: AlertMediumIcon, // no viewbox, 24
  warning: AlertHighIcon, // no viewbox, 24
  done: AllDone, // has viewbox, 128
};

const InformationalModalBase = ({ title, variant, message, footer, ...modalProps }) => {
  const Icon = INFORMATIONAL_ICONS[variant];
  const viewbox = variant === 'done' ? '0 0 128 128' : '0 0 24 24';

  return (
    <Modal className='informational-modal' {...modalProps} width={500} footer={footer ? footer : React.Fragment}>
      <div className='informational-modal-content'>
        <Icon width={64} height={64} viewbox={viewbox} className='informational-modal-icon' />
        <Heading2 className='informational-modal-heading' data-testid='informational-modal-title'>
          {title}
        </Heading2>
        <BodyText>{message}</BodyText>
      </div>
    </Modal>
  );
};

InformationalModalBase.propTypes = {
  title: string,
  variant: oneOf(Object.keys(INFORMATIONAL_ICONS)),
  message: node,
  footer: node,
};

export default React.memo(InformationalModalBase);
